import Component from '@glimmer/component';
import { service } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import { reloadRecord } from 'tio-data/requests/save-record';
import PhoneVerificationFlow from 'tio-employee/components/app/phone-verification/flow';
import matchMedia from 'tio-common/helpers/match-media';
import type { Store } from '@warp-drive/core';
import type SessionContextService from 'tio-employee/services/session-context';

/** Below this the card is too narrow for Send beside the field, which clips the number. */
const ROOMY_QUERY = '(min-width: 768px)';

/** The mobile-number recommendation's action: the shared flow, inline, under the card's header. */
export default class BetaHomePhoneRecommendation extends Component {
  @service declare sessionContext: SessionContextService;
  @service declare store: Store;

  /**
   * Re-reads the phone rows, which is what retires the item or turns it into finishing.
   * Not `sessionContext.load`: it logs out on any failure.
   */
  refresh = dropTask(async () => {
    const employee = this.sessionContext.currentEmployee;
    if (!employee) return;

    try {
      await reloadRecord(this.store, employee, { include: 'phone-numbers' });
    } catch {
      // The item stays as it was until the next page load re-reads the employee.
    }
  });

  <template>
    {{! Attribution only. The surface list is server-validated and holds no
        dashboard member, so this rides the overlay it shares a flag with. }}
    <PhoneVerificationFlow
      @headless={{true}}
      @size="sm"
      @entryLayout={{if (matchMedia ROOMY_QUERY) "inline" "stacked"}}
      @surface="postLoginOverlay"
      @phoneNumber={{this.sessionContext.currentEmployee.activeMobilePhoneNumber.number}}
      @onVerified={{this.refresh.perform}}
      @onDeferred={{this.refresh.perform}}
    />
  </template>
}
